import type { Person } from '../../eventsApi/persons/person'
import type { User } from '../../usersApi/users/user'
import type { Schedule } from '../schedules/schedule'
import type { AppointmentItem } from './appointment-item'
import type { AppointmentRepeat } from './appointment-repeat'
import type { AppointmentResource } from './appointment-resource'
import type { AppointmentConsumption } from './appointment-consumption'
import type { AppointmentStatus } from './appointments.enum'
import type { SignAppointment } from './dto/sign-appointment.dto'

export class Appointment {
    appointmentId: string
    createdAt: Date
    updatedAt: Date
    start: Date
    end: Date
    status: AppointmentStatus
    companyId: string
    userId: string // atendente (só vale para appointments.repository.consulting(...))
    appointment_userId: string // usuário que fez o agendamento (só vale para appointments.repository.consulting(...))
    personId: string
    notes: string
    group: string
    scheduleId?: string
    items?: AppointmentItem[]
    person?: Person
    groupId?: string
    recurrencies: Appointment[]
    repeat?: AppointmentRepeat
    user?: User
    auto: boolean
    invoiceId?: string
    source: string
    resources: AppointmentResource[]
    consumption?: AppointmentConsumption[]
    schedule?: Schedule
    sign?: SignAppointment
    signed: boolean
    groupPos: number
    groupTotal: number
    blockRuleId?: string
    manuallyModified?: boolean
}
